import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'root',
  'imageArea',
  'image',
  'imagePlaceholder',
  'labelArea',
  'label',
  'viewDetails'
]);

/**
 * Option-step swatch cards — Figma 6492:5801 / 6492:6542 (list), 6492:4295 / 6492:6558 (item).
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 * keys: ("root" | "imageArea" | "image" | "imagePlaceholder" | "labelArea" | "label" | "viewDetails")[]
 * }>} SwatchOptionCardStyles
 */
const SwatchOptionCard = helpers.defineMultiStyleConfig({
  baseStyle: ({isDisabled, isSelected}) => ({
    root: {
      alignItems: 'stretch',
      bg: 'white',
      border: isSelected ?
        '2px solid rgba(27, 26, 24, 0.90)' :
        '2px solid transparent',
      borderRadius: '4px',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      display: 'flex',
      flexDirection: 'column',
      gap: {base: '14px', lg: '10px'},
      overflow: 'hidden',
      pb: {base: '8px', lg: '11.5px'},
      transition: 'border-color 0.15s ease',
      w: 'full',
      _hover: {
        bg: 'white',
        borderColor: isSelected ?
          'rgba(27, 26, 24, 0.90)' :
          'transparent',
        ...(!isSelected && !isDisabled && {
          borderRadius: '6px',
          boxShadow: {lg: 'inset 0 0 0 1px rgba(27, 26, 24, 0.9)'},
        }),
      },
    },
    imageArea: {
      flexShrink: 0,
      h: {base: 'auto', lg: '91px'},
      overflow: 'hidden',
      p: {base: '4px', lg: '6px'},
      position: 'relative',
      w: 'full',
    },
    image: {
      borderRadius: {base: '4px', lg: '3px'},
      display: 'block',
      h: {base: '82.75px', lg: '85px'},
      maxH: {base: '82.75px', lg: '85px'},
      objectFit: 'cover',
      w: 'full',
    },
    imagePlaceholder: {
      bg: 'gray.100',
      borderRadius: {base: '4px', lg: '3px'},
      h: {base: '82.75px', lg: '85px'},
      w: 'full',
    },
    labelArea: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: {base: '6px', lg: '4px'},
      justifyContent: 'center',
      px: {base: '8px', lg: '6px'},
      w: 'full',
    },
    label: {
      color: 'brandColors.greyscale',
      fontFamily: 'body',
      fontSize: {base: '13px', lg: '16px'},
      fontStyle: 'normal',
      fontVariantNumeric: 'lining-nums proportional-nums',
      fontWeight: 600,
      lineHeight: {base: 1.2, lg: 1.4},
      margin: 0,
      textAlign: 'center',
      w: 'full',
      sx: {
        '.product-view--simple &': {
          color: 'black',
        },
      },
    },
    viewDetails: {
      color: 'brandColors.viewDetailsLink',
      cursor: 'pointer',
      display: 'block',
      fontFamily: 'body',
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 1.2,
      margin: 0,
      textAlign: 'center',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      _hover: {
        color: 'brandColors.primaryDarkLinen',
        textDecoration: 'none',
      },
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'brandColors.viewDetailsLink',
        outlineOffset: '2px',
      },
    },
  }),
});

export default SwatchOptionCard;
